import React, { useState, useContext, useEffect } from 'react';
import './styles.css';
import { Image } from '../Image';
import LinesEllipsis from 'react-lines-ellipsis';
import { Modal } from '../Modal';
import { GetStatusLoja, SetTitleFavicon } from '../../utils/utils';
import { Shimmer } from '../Shimmer';
import { GlobalContext } from '../../contexts/HomeContext';
// import LogoWhats from '../../img/whatsapp.png';
// import LogoInstagram from '../../img/instagram.png';
import P from 'prop-types';

export const Banner = React.memo(function Banner({ showStatusLoja = true }) {
  const { dadosApp, statusLoja, setStatusLoja } = useContext(GlobalContext);
  //const [statusText, setStatusText] = useState(''); //statusLoja.StatusLoja ? 'Loja Aberta' : 'Loja Fechada'
  const bg = 'https://www.garcomweb.com.br/office/' + dadosApp.Empresa.Config.banner_desktop;

  const fantasia = dadosApp.Empresa.Empresa.fantasia_edicao
    ? dadosApp.Empresa.Empresa.fantasia_edicao
    : dadosApp.Empresa.Empresa.fantasia;
  SetTitleFavicon(dadosApp.Empresa.Empresa.logo, dadosApp.Empresa.Empresa.fantasia);

  const endereco =
    dadosApp.Empresa.Empresa.endereco +
    ', ' +
    dadosApp.Empresa.Empresa.endereco_numero +
    ', ' +
    dadosApp.Empresa.Empresa.endereco_bairro +
    ', ' +
    dadosApp.Empresa.Empresa.endereco_cidade +
    ', ' +
    dadosApp.Empresa.Empresa.endereco_estado;

  const [visibility, setVisibility] = useState('none');

  // const handleStatusLoja = useCallback(
  //   async (_statusLoja) => {
  //     if (_statusLoja.StatusLoja) {
  //       setStatusText('Loja Aberta');
  //       return;
  //     }

  //     let result = await GetTextStatusLoja(dadosApp?.Empresa?.Config);
  //
  //     if (result.text === 'Loja Fechada') {
  //       result = await GetNextDayOpened(new Date(Date.now()), dadosApp?.Empresa?.Config);
  //     }
  //     setStatusText(result.text);
  //   },
  //   [dadosApp],
  // );

  const ocultarModal = () => {
    //handleStatusLoja(statusLoja);
    GetStatusLoja(dadosApp, statusLoja, setStatusLoja);
    if (dadosApp?.Empresa?.Empresa?.tipo_app === 'DELIVERY') setVisibility(visibility == 'none' ? 'block' : 'none');
  };

  // useEffect(() => {
  //   handleStatusLoja(statusLoja);
  // }, [handleStatusLoja, statusLoja, statusText]);

  useEffect(() => {
    GetStatusLoja(dadosApp, statusLoja, setStatusLoja);
  }, [dadosApp, statusLoja, setStatusLoja]);

  return (
    <>
      <div className="banner" style={{ height: showStatusLoja ? 400 : 320 }}>
        {/* <div className="banner" style={{ height: 400 }}> */}
        <div className="top" style={{ backgroundImage: `url(${bg})`, height: showStatusLoja ? 400 : 320 }}>
          <div
            className="sombra margem"
            style={{ backgroundColor: fantasia ? 'rgba(0, 0, 0, 0.4)' : 'white', height: showStatusLoja ? 400 : 320 }}
          >
            {fantasia ? (
              <>
                <div className="logo_container">
                  {dadosApp.Empresa.Empresa.logo !== '' && (
                    <Image src={dadosApp.Empresa.Empresa.logo} alt="logo" size={115} />
                  )}
                </div>
                <h1 className="container title_categoria capitalize">
                  <LinesEllipsis
                    text={fantasia ? fantasia.toLowerCase() : fantasia}
                    maxLine={1}
                    ellipsis="..."
                    trimRight
                    basedOn="letters"
                    component="p"
                  />
                </h1>

                <LinesEllipsis
                  text={endereco ? endereco.toLowerCase() : endereco}
                  maxLine={2}
                  ellipsis="..."
                  className="capitalize"
                  trimRight
                  basedOn="letters"
                  component="p"
                />

                {showStatusLoja && (
                  <div className="container status_loja" style={{ cursor: 'pointer' }}>
                    <p
                      onClick={ocultarModal}
                      style={{ color: `${statusLoja.StatusLoja ? 'rgb(0, 180, 164)' : 'red'}` }}
                    >
                      {/* {statusLoja.StatusLoja ? 'Loja Aberta' : statusText} */}
                      {statusLoja.StatusLoja ? 'Loja Aberta' : statusLoja.StatusText}
                    </p>
                    {!statusLoja.StatusLoja && (
                      <div
                        style={{
                          color: '#FFF',
                          textAlign: 'center',
                          marginTop: 10,
                          fontWeight: 500,
                          fontSize: 14,
                          display: dadosApp?.Empresa?.Config?.agendamento === 1 ? 'block' : 'none',
                        }}
                      >
                        {dadosApp?.Empresa?.Config?.agendamento === 1 ? 'Aceitamos Agendamento' : ''}
                      </div>
                    )}
                  </div>
                )}
              </>
            ) : (
              <Shimmer type="Banner" />
            )}
          </div>
        </div>
      </div>

      {visibility === 'block' && (
        <Modal
          title={fantasia}
          isFooter={true}
          visibility={visibility}
          param={dadosApp}
          page="INFORMACOES"
          btnOnClickClose={ocultarModal}
        />
      )}
    </>
  );
});

Banner.propTypes = {
  showStatusLoja: P.bool,
};
